import Module from './breedPreview'
export default Module
